import React from 'react';
import './About.css';
import Header from './Header';
import Footer from './Footer';

const About = () => {

  return (
    <div className="about-app">
      {/* Header Component */}
      <Header activePage="about" />

      {/* Main About Content */}
      <main className="about-page">
        <div className="about-container">
          <div className="about-content">
            {/* Left Side - Content */}
            <div className="content-section">
              <h1 className="about-title">About Me.</h1>
              <div className="about-text">
                <p className="about-paragraph">
                  I'm a multidisciplinary designer passionate about creating <strong>user-centered</strong> and <strong>visually engaging digital experiences</strong>. Currently, I work as a part-time Product Designer at Bluetelcast Software Company, where I contribute to crafting impactful design solutions.
                </p>
                
                <p className="about-paragraph">
                  Previously I worked as a Mid-Level Product Designer where my key role was to enhance the design quality and manage the design team. I have also mentored 16+ Product Design Interns on rapid iteration and customer focused design thinking, successfully transitioning 90% of them into junior designer roles and guided junior designers on stakeholder presentation and feedback strategy and helped them run user testing & A/B testing workshops that improved product UX decisions.
                </p>
                
                <p className="about-paragraph">
                  I have also successfully conducted UX/UI Hackathon with 20+ participants, guiding teams to create three functional prototypes that solved practical design problems.
                </p>
              </div>
            </div>

            {/* Right Side - Image */}
            <div className="image-section">
              <div className="about-image-container">
                <img 
                  src="/aboutme.jpg" 
                  alt="Subeksha Thapa - Product Designer" 
                  className="about-profile-image"
                />
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Services Section */}
      <section className="services-section">
        <div className="services-container">
          <h2 className="services-title">I can help you with...</h2>
          <div className="services-grid">
            <div className="service-item">
              <div className="service-number">01</div>
              <h3 className="service-title">Research & Analysis</h3>
              <p className="service-description">
                I have also successfully conducted UX/UI Hackathon with 20+ participants, guiding teams to create three functional prototypes that solved practical design problems.
              </p>
            </div>
            <div className="service-item">
              <div className="service-number">02</div>
              <h3 className="service-title">Low & High Fidelity Wireframes</h3>
              <p className="service-description">
                I have also successfully conducted UX/UI Hackathon with 20+ participants, guiding teams to create three functional prototypes that solved practical design problems.
              </p>
            </div>
            <div className="service-item">
              <div className="service-number">03</div>
              <h3 className="service-title">Animations & Prototypes</h3>
              <p className="service-description">
                I have also successfully conducted UX/UI Hackathon with 20+ participants, guiding teams to create three functional prototypes that solved practical design problems.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer Component */}
      <Footer />
    </div>
  );
};

export default About;
